import { render, staticRenderFns } from "./Bbyklist2.vue?vue&type=template&id=1142938a&scoped=true"
import script from "./Bbyklist2.vue?vue&type=script&lang=js"
export * from "./Bbyklist2.vue?vue&type=script&lang=js"
import style0 from "./Bbyklist2.vue?vue&type=style&index=0&id=1142938a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142938a",
  null
  
)

export default component.exports